import React, { useMemo } from 'react'
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg'
import s from './styles/FiltersSortBar.module.scss'
import { useFiltersSortBar } from './hooks/useFiltersSortBar'
import { useMediaQuery } from 'react-responsive'
import { observer } from 'mobx-react-lite'

export const FiltersSortBar = observer(
	({
		className = '',
		baseItems = [],
		defaultId,
		activeIds,
		onChange,

		extraItems = [],
		onRemoveExtra,
		onExtraClick,

		showSearch = false,
		onSearch,
		searchAriaLabel = 'Search',

		itemClassName = '',
		itemActiveClassName = '',
		extraItemClassName = '',
		extraActiveClassName = '',
		extraRemoveClassName = '',
		searchBtnClassName = '',
	}) => {
		const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

		const { isActive, handleClickBase } = useFiltersSortBar({
			baseItems,
			activeIds,
			onChange,
			defaultId,
		})

		const extraActiveSet = useMemo(() => {
			return new Set(
				(extraItems || []).filter(i => i?.isActive).map(i => String(i.id))
			)
		}, [extraItems])

		return (
			<div className={`${s.wrap} ${className}`.trim()}>
				{showSearch && (
					<button
						type="button"
						className={`${s.searchBtn} ${searchBtnClassName}`.trim()}
						onClick={onSearch}
						aria-label={searchAriaLabel}
					>
						<span className={s.searchBtn__icon}>
							<SearchIcon />
						</span>
					</button>
				)}

				<div className={s.chips}>
					{isMobile &&
						extraItems.map(item => {
							const isActiveExtra = extraActiveSet.has(String(item.id))
							const canRemove = item?.removable !== false
							console.log('extraItems item', item)

							return (
								<button
									key={item.id}
									type="button"
									className={`${s.chip} ${s.chipExtra} ${extraItemClassName} ${
										isActiveExtra
											? `${s.chipActive} ${extraActiveClassName}`
											: ''
									}`.trim()}
									onClick={() => {
										if (typeof item?.onClick === 'function')
											return item.onClick(item)
										onRemoveExtra?.(item)
									}}
								>
									<span className={s.chip__text}>{item.label}</span>

									{canRemove && (
										<span
											className={`${s.chip__remove} ${extraRemoveClassName}`.trim()}
											role="button"
											tabIndex={0}
											onClick={e => {
												e.stopPropagation()
												onRemoveExtra?.(item)
											}}
											onKeyDown={e => {
												if (e.key === 'Enter' || e.key === ' ') {
													e.preventDefault()
													e.stopPropagation()
													onRemoveExtra?.(item)
												}
											}}
											aria-label="Remove"
										>
											×
										</span>
									)}
								</button>
							)
						})}

					{baseItems.map(item => {
						const active = isActive(item.id)

						return (
							<button
								key={item.id}
								type="button"
								className={`${s.chip} ${itemClassName} ${
									active ? `${s.chipActive} ${itemActiveClassName}` : ''
								}`.trim()}
								onClick={() => handleClickBase(item)}
							>
								<span className={s.chip__text}>
									{item.label ?? item.value ?? ''}
								</span>
							</button>
						)
					})}

					{!isMobile &&
						extraItems.map(item => {
							const isActiveExtra = extraActiveSet.has(String(item.id))
							const canRemove = item?.removable !== false
							console.log('extraItems item', item)

							return (
								<button
									key={item.id}
									type="button"
									className={`${s.chip} ${s.chipExtra} ${extraItemClassName} ${
										isActiveExtra
											? `${s.chipActive} ${extraActiveClassName}`
											: ''
									}`.trim()}
									onClick={() => {
										if (typeof item?.onClick === 'function')
											return item.onClick(item)
										onRemoveExtra?.(item)
									}}
								>
									<span className={s.chip__text}>{item.label}</span>

									{canRemove && (
										<span
											className={`${s.chip__remove} ${extraRemoveClassName}`.trim()}
											role="button"
											tabIndex={0}
											onClick={e => {
												e.stopPropagation()
												onRemoveExtra?.(item)
											}}
											onKeyDown={e => {
												if (e.key === 'Enter' || e.key === ' ') {
													e.preventDefault()
													e.stopPropagation()
													onRemoveExtra?.(item)
												}
											}}
											aria-label="Remove"
										>
											×
										</span>
									)}
								</button>
							)
						})}
				</div>
			</div>
		)
	}
)
